import '@babel/polyfill'
import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy, {defaultIconPack: 'fas'})

import App from './App.vue'
import 'leaflet/dist/leaflet.css';

import router from './router'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import {createProvider} from '@shared/vue-apollo'
import {environment} from "./environments/environment";


Vue.config.productionTip = false
Vue.prototype.$user = {
  name: null,
  permissions: null,
}
Vue.prototype.$environment = environment

let vue = new Vue({
  router,
  apolloProvider: createProvider(environment),
  render: h => h(App)
})
vue.$mount('#app')
